export const SMALL_ANIMATION_DELAY = 300;
export const MEDIUM_ANIMATION_DELAY = 800;
export const LONG_ANIMATION_DELAY = 6000;
